// components/project-details/ProjectTimeline.js
import React from 'react';
import { FireIcon, ChatBubbleLeftRightIcon, WrenchIcon, CheckCircleIcon } from '@heroicons/react/24/solid';
import styles from './ProjectDetails.module.css';

const ProjectTimeline = ({ project }) => {
  const statusFlow = [
    { 
      key: 'new_enquiry', 
      label: 'New Enquiry', 
      icon: FireIcon,
      dateKey: 'enquiryDate'
    },
    { 
      key: 'in_conversation', 
      label: 'In Conversation', 
      icon: ChatBubbleLeftRightIcon,
      dateKey: 'conversationDate'
    },
    { 
      key: 'project_started', 
      label: 'Project Started', 
      icon: WrenchIcon,
      dateKey: 'projectStartedDate'
    },
    { 
      key: 'project_completed', 
      label: 'Completed', 
      icon: CheckCircleIcon,
      dateKey: 'completedDate'
    }
  ];

  const getCurrentStepIndex = () => {
    const currentStatus = project?.status;
    return statusFlow.findIndex(step => step.key === currentStatus);
  };

  const currentStepIndex = getCurrentStepIndex();

  return (
    <div className={styles.timelineCard}>
      <div className={styles.timelineWrapper}>
        {statusFlow.map((step, index) => {
          const isCompleted = index <= currentStepIndex;
          const isCurrent = index === currentStepIndex;
          const date = project?.stage?.[step.dateKey];
          const Icon = step.icon;
          
          return (
            <div key={step.key} className={styles.timelineStep}>
              <div className={styles.timelineContent}>
                <div 
                  className={`${styles.timelineIcon} ${isCompleted ? styles.completed : ''} ${isCurrent ? styles.current : ''}`}
                >
                  {isCompleted ? (
                    <Icon style={{ width: '1.25rem', height: '1.25rem' }} />
                  ) : (
                    <span className={styles.stepNumber}>{index + 1}</span>
                  )}
                </div>
                <div className={styles.timelineInfo}>
                  <div className={`${styles.timelineLabel} ${isCompleted ? styles.completed : ''}`}>
                    {step.label}
                  </div>
                  {date && (
                    <div className={styles.timelineDate}>
                      {new Date(date.seconds ? date.seconds * 1000 : date).toLocaleDateString()}
                    </div>
                  )}
                </div>
              </div>
              {index < statusFlow.length - 1 && (
                <div className={`${styles.timelineConnector} ${isCompleted && index < currentStepIndex ? styles.completed : ''}`} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProjectTimeline;